const Connect = require("react-redux").connect;
const BodyModelForm = require("components/BodyModelForm");
const CroquisAct = require("actions/croquis");
const SnackbarAct = require("actions/snackbar");

const internals = {};

internals.connect = Connect(
    (state, ownProps) => ({
        croquis: state.croquis.all[ownProps.match.params.id],
        submitText: "Save My Body Model"
    }),
    {
        updateFieldAction: CroquisAct.croquisMeasurementUpdate,
        updateTitleAction: CroquisAct.croquisTitleUpdate,
        onSubmitClick: CroquisAct.save,
        fetchData: CroquisAct.fetchCroquis,
        onError: SnackbarAct.messageSnackbar
    }
);

module.exports = internals.connect(BodyModelForm);



// WEBPACK FOOTER //
// ./src/routes/body-model-edit/containers/BodyModelEdit.js